var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 79",
    style: {
      enableBackground: "new 0 0 79 79"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9AB8D1;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    transform: "translate(-129.485 39)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    className: "st0",
    cx: 169,
    cy: 0.5,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.5,17.1h-22.4v-4.4l10.6-11.3c1.5-1.6,2.5-3,3.2-4.2s1-2.3,1-3.4c0-1.5-0.4-2.6-1.1-3.4 c-0.7-0.8-1.8-1.2-3.1-1.2c-1.5,0-2.6,0.5-3.5,1.5c-0.8,1-1.3,2.3-1.3,4h-6.5c0-2,0.5-3.8,1.4-5.5c1-1.6,2.3-2.9,4-3.9 c1.7-0.9,3.7-1.4,5.9-1.4c3.4,0,6,0.8,7.9,2.4s2.8,3.9,2.8,6.9c0,1.6-0.4,3.3-1.3,4.9s-2.3,3.6-4.3,5.9l-7.4,7.8h14.1V17.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo2);
export default __webpack_public_path__ + "static/media/no2.4afe0737d00b2fc967d78db9eb0f9c33.svg";
export { ForwardRef as ReactComponent };